module.exports = __webpack_public_path__ + "static/media/microsoft-icon.2dab6627.svg";